import { api } from "../lib/api";


export const getMine = () =>
  api
    .get("/auth/me/share-settings")
    .then((response) => response.data);


export const updateMine = (payload) =>
  api
    .put(
      "/auth/me/share-settings",
      payload
    )
    .then((response) => response.data);


export const getTenant = () =>
  api
    .get("/tenant/share-settings")
    .then((response) => response.data);


export const updateTenant = (payload) =>
  api
    .put(
      "/tenant/share-settings",
      payload
    )
    .then((response) => response.data);
